<template functional>
	<article :class="[data.class, data.staticClass]" class="space-y-32">
		<header class="font-bold text-20 tablet:text-24">
			<slot>{{ props.title }}</slot>
		</header>
		<content v-html="props.content" />
	</article>
</template>

<script>

export default {
	props: {
		title: {
			type: String,
			required: true,
		},
		content: {
			type: String,
			required: true,
		},
	},
};
</script>
